export function formatBankAccountNumber( accountNo ){
  if (accountNo === undefined || accountNo === null) {
    return '';
  }
  return accountNo.match(/[A-Z]{2}|(?:(?:\d{2}|\d{4})(?=(\d{4})*$))/g)?.join(" ");
}